<footer class="footer ">
    <div fxLayout="row wrap" fxLayoutAlign="space-between" fxLayoutGap="" class="footer-wrapper theme-container">
        <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="40">
            <div class="social-media">
                <p>社群媒體</p>
                <mat-list>
                    <mat-list-item>
                        <a href="https://www.facebook.com/ccps.phc.edu.tw/?view_public_for=1655150511375533" target="_blank" rel="facebook">facebook 粉絲專頁</a>
                    </mat-list-item>
                    <mat-list-item> 
                        <a href="https://www.facebook.com/ccps.phc.edu.tw/videos" target="_blank" rel="youtube">facebook 影片頻道</a>
                    </mat-list-item>
                    <mat-list-item> 
                        <a href="https://www.youtube.com/channel/UC2piCohBJ0VDj4m6q5ePN2g/" target="_blank" rel="youtube">youtube 影片頻道</a>
                    </mat-list-item>
                    
                </mat-list>
            </div>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="30" fxFlex.sm="60">
            <div class="contact-information">
                <p>聯絡方式</p>
                <mat-list>
                    <mat-list-item>
                        <i class="material-icons">location_city</i>
                        <span>澎湖縣馬公市中興里民生路38號</span>
                    </mat-list-item>
                    <mat-list-item> 
                        <i class="material-icons">
                            phone
                        </i>
                        <span>(06)927-2758</span>
                    </mat-list-item>
                    <mat-list-item> 
                        <i class="material-icons">
                            mail_outline
                        </i>
                        <span>ccps@mail.phc.edu.tw</span>
                    </mat-list-item>
                    <mat-list-item> 
                        <i class="material-icons">
                            local_printshop
                            </i>
                        <span>(06)927-7485</span>
                    </mat-list-item>
                    <mat-list-item> 
                        
                    </mat-list-item>
                </mat-list>
            </div>
            
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" >
            <div class="google-map">
                <google-map
                height="300px"
                width="100%"
                [center]="center"
                [zoom]="zoom"
                ></google-map>
                
            </div>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0px">
        <p>中正國小全球資訊網由中正國小教學團隊製作，以<a class="cc" href="http://creativecommons.org/licenses/by-nc-sa/3.0/tw/">創用CC 姓名標示-非商業性-相同方式分享 3.0 台灣 授權條款</a>釋出。</p>
    </div>
</footer>